import {
  Box,
  Button,
  Container,
  ContainerProps,
  Flex,
  Heading,
  IncrementInput,
  LinkButton,
  Price,
  Skeleton,
  Stack,
  StarRating,
  Text,
  Title,
  useToast,
  VisuallyHidden,
  BoxProps,
  Collapse,
  Image,
  formatCurrency,
} from '@thirstycamel/ui'
import type { CoreProductEntity } from '@ts/core/src/modules/coreproduct/coreproduct.entity'
import React, { memo, useCallback, useEffect, useState } from 'react'
import { useUser } from '../../hooks/useUser'
import { useActions, useStore } from '../../store/hooks'
import { getNiceErrorMessage } from '../../utils/getNiceErrorMessage'
import ProductAvailability from '../ProductAvailability'
import ProductBadge from '../ProductBadge'
import ProductFavouriteStatus from '../ProductFavouriteStatus'
import ProductImagePreview from '../ProductImagePreview'
import ProductBundleGroupEntity from '@ts/core/src/modules/productbundle/productbundlegroup.entity'
import imageProxy from '../../utils/imageProxy'

export interface ProductBundleOverviewGroupProps extends BoxProps {
  group: ProductBundleGroupEntity
  price: number
}

export function ProductBundleOverviewGroup({
  group,
  price,
  ...restProps
}: ProductBundleOverviewGroupProps) {
  const [isOpen, setOpen] = useState(false)

  return (
    <Box {...restProps}>
      <Button
        variant="unstyled"
        onClick={() => setOpen(state => !state)}
        justifyContent="space-between"
        rightIcon={isOpen ? 'minus' : 'add'}
        color="pink.500"
        w="100%"
        py={4}
        pl={1}
        pr={2}
        whiteSpace="break-spaces"
      >
        <Heading color="pink.500" textTransform="uppercase">
          {group.heading} {formatCurrency(price / 100)}
        </Heading>
      </Button>

      <Collapse isOpen={isOpen}>
        <Box py={5}>
          <Stack>
            {group.products.map(product => (
              <Flex key={product.id} align={['flex-start', 'center']}>
                <Image
                  src={imageProxy(product.media?.[0]?.filename, { height: 64 })}
                  size={['36px', '48px']}
                  flexShrink={0}
                  objectFit="contain"
                  mr={3}
                  mt={[1, 0]}
                  bg="white"
                  border="1px"
                  borderColor="gray.200"
                />

                <Stack spacing={0} justify="center">
                  <Text fontSize={['md', 'lg']} fontWeight="medium">
                    {product.productGroup?.brand?.name}
                  </Text>

                  <Text fontSize={['sm', 'md']} color="blackAlpha.700">
                    {product.productGroup?.name} {product.unitSize}mL {product.factorDescription}
                  </Text>
                </Stack>
              </Flex>
            ))}
          </Stack>
        </Box>
      </Collapse>
    </Box>
  )
}

export default memo(ProductBundleOverviewGroup)
